interface ToolbarWidths {
    available: number;
    /** The time range picker, alone at the left. */
    start: number;
    /** The controls at the start of the right-hand group that never move into the menu; 0 if none. */
    endPinned: number;
    /** One icon button. The actions and the menu button are all this size. */
    button: number;
    gap: number;
    /** Between items in the right-hand group. */
    endGap: number;
}

/** How many of `total` actions stay in the toolbar; the rest go in the menu. */
export function countVisibleActions(widths: ToolbarWidths, total: number): number {
    const { available, start, endPinned, button, gap, endGap } = widths;
    const fits = (buttons: number) => {
        const items = buttons + (endPinned > 0 ? 1 : 0);
        const end = items === 0 ? 0 : gap + endPinned + buttons * button + (items - 1) * endGap;
        return start + end <= available;
    };
    if (fits(total)) return total;
    // The menu button takes a slot of its own.
    for (let visible = total - 1; visible > 0; visible--) {
        if (fits(visible + 1)) return visible;
    }
    return 0;
}
